import abi from "../abi/Ethm.json";
import abi2 from "../abi/Minter.json";
import toast from "react-hot-toast";
import { useAccount, useContractRead, useContractWrite } from "wagmi";
import { Button, Flex, Text } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import whiteList from '../merkletree/merkletree.json'
import { ethers } from "ethers";

type mintButtonProps = {
  primary?: boolean;
  link?: boolean;
  amount: number;
  onClick?: () => void;
};

const MintButton = (props: mintButtonProps) => {
  const { data: account } = useAccount();
  const [mintList, setMintList] = useState<any>(null);

  function createBetterWL(address: string) {
    return Object.entries(whiteList['mints']).find(([key, value]) => {
      return key === address
    })
  }



  // function checkWhiteList(address: string) {
  //   return Object.keys(whiteList['mints']).includes(address)
  // }


  const preSaleState = useContractRead({
    addressOrName: process.env.REACT_APP_ADDRESS || "",
    contractInterface: abi,
  }, 'preSaleIsActive',
    {
      onError(error) {
        console.log("balanceOfRead read error")
      },
    },
  )

  const saleState = useContractRead({
    addressOrName: process.env.REACT_APP_ADDRESS || "",
    contractInterface: abi,
  }, 'saleIsActive',
    {
      onError(error) {
        console.log("balanceOfRead read error")
      },
    },
  )

  const hasClaimed = useContractRead({
    addressOrName: "0xae87f4cde4301b599f3e42a0e524eaf49ee3080f" || "",
    contractInterface: abi2,
  }, 'hasClaimed',
    {
      args : [account?.address],
      onError(error) {
        console.log("balanceOfRead read error")
      },
    },
  )

  const freeMintActive = useContractRead({
    addressOrName: "0xae87f4cde4301b599f3e42a0e524eaf49ee3080f" || "",
    contractInterface: abi2,
  }, 'freeMintActive',
    {
      onError(error) {
        console.log("balanceOfRead read error")
      },
    },
  )

  // const { write: preSaleMint } = useContractWrite({
  //   addressOrName: process.env.REACT_APP_ADDRESS || "",
  //   contractInterface: abi,
  // }, 'preSaleMint',
  //   {
  //     args: [props.amount],

  //     overrides: { value: ethers.utils.parseEther((0.005 * props.amount).toString()) },
  //     onError(error) {
  //       // console.log("mint error", error.message.split(';')[0])
  //       toast.error(error.message.split('execution reverted:')[1].split(',')[0]);
  //     },
  //   })

  // const { write: mint } = useContractWrite({
  //   addressOrName: process.env.REACT_APP_ADDRESS || "",
  //   contractInterface: abi,
  // }, 'mint',
  //   {
  //     args: [props.amount],

  //     overrides: { value: ethers.utils.parseEther((0.005 * props.amount).toString()) },
  //     onError(error) {
  //       // console.log("mint error", error.message.split(';')[0])
  //       toast.error(error.message.split('execution reverted:')[1].split(',')[0]);
  //     },
  //   })
  
  const { write: freemint } = useContractWrite({
    addressOrName: "0xae87f4cde4301b599f3e42a0e524eaf49ee3080f",
    contractInterface: abi2,
  }, 'mint',
    {
      onError(error) {
        // console.log("mint error", error.message.split(';')[0])
        toast.error(error.message.split('execution reverted:')[1].split(',')[0]);
      },
    })

  useEffect(() => {
    if (account) {
      setMintList(createBetterWL(account.address as string))
      if (preSaleState.data) {
        console.log("preSale", preSaleState.data)
      } else if (saleState.data) {
        console.log("mainSale", saleState.data)
      }
      if (freeMintActive.data) {
        console.log("freeMint", freeMintActive.data)
      }
    }
  }, [account, mintList, preSaleState.data, saleState.data, freeMintActive.data])

  const onMint = async () => {
    if (account) {
      if (freeMintActive.data) {
        try {
          await freemint({
            args: [props.amount], overrides: { value: ethers.utils.parseEther((0.005 * (hasClaimed.data ? props.amount : props.amount - 1)).toPrecision(3)) }
          })
        } catch (e: any) {
          toast.error(e.message);
        }
      } else {
        toast.error("Mint not open yet")
      }
    }
//       try {
//         if (preSaleState.data) {
//           if (mintList) {
//             await preSaleMint({
//               args: [mintList[1].amount, isClaimed.data ? props.amount : props.amount - mintList[1].amount, mintList[1].proofs], overrides: { value: ethers.utils.parseEther((0.005 * (isClaimed.data ? props.amount : props.amount - mintList[1].amount)).toPrecision(3)) }
//             })
//           } else {
//             toast.error("You are not on the free mint list")
//           }
//           // await mint();
//         } else if (saleState.data) {
//           await mint({ args: [props.amount], overrides: { value: ethers.utils.parseEther((0.005 * props.amount).toPrecision(3))}
// })
//         } else {
//           toast.error("Sale not active yet")
//         }

//       } catch (e: any) {
//         console.log("ye")
//         toast.error(e.message);
//       }
    else if (!account)
      toast.error("Please connect to your wallet", {
        style: {
          border: "1px solid #131313",
          padding: "16px",
          color: "#fff",
        },
        iconTheme: {
          primary: "#6200ff",
          secondary: "#fff",
        },
      });
  };

  return (
    <Flex flexDirection='column' justify='center' align='center' padding='20px 0px'>
      <Text color="yellow" fontWeight={700}>{freeMintActive.data ? "Mint open" : "Mint closed"}</Text>
      <Button onClick={() => onMint()} {...props}>Mint</Button>
      {freeMintActive.data && <Text p={1} color="yellow">{(freeMintActive.data && !hasClaimed.data ? `You can still claim your freemints` : 'You claimed your freemint')}</Text>}
    </Flex>

  );
};
export default MintButton;
